/** The panel-and-widget chunk, fetched once by whichever asks first. */
export const journeyChunk = {
  loaded: null,
  load() {
    return pending ??= import(/* webpackChunkName: 'forum/components/Journey', webpackMode: 'lazy-once' */ './components/Journey').then(mod => {
      journeyChunk.loaded = mod;
      m.redraw();
      return mod;
    });
  }
};
let pending = null;flarum.reg.addChunkModule('ernestdefoe-onramp:forum/components/Journey', '840', 'ernestdefoe-onramp', 'forum/components/Journey');